module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-42.4d1639a9.png";